const MapLegend = () => (
	<div>
		<h4>Map layer legend</h4>
		<p>Click on the legend to expand.</p>
	</div>
);

export default MapLegend;
